import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { LISTING_TYPE_ROUTES } from '../../utils';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { getCreateListingRoute } from 'utils';
import { ListingType } from 'models/Listing';

import './BusinessInfoNavigation.styles.scss';
import './BusinessInfoNavigation.styles.responsive.scss';

type BusinessInfoNavigationProps = {
  className?: string;
};

const BusinessInfoNavigation: React.FC<BusinessInfoNavigationProps> = (
  props,
) => {
  const { className } = props;

  const { pathname } = useLocation();

  const { dealRoomId, id } = useParams();

  const { t } = useTranslation();

  const classes = classNames('business-info-navigation', className);

  return (
    <div className={classes}>
      <p className="lcw-page__heading__title">{t('businessListingInfo')}</p>

      <div className="business-info-navigation__content">
        <label className="required">{t('whatIsListingType')}</label>
        <nav>
          <ul>
            {Object.entries(LISTING_TYPE_ROUTES).map(
              ([key, { route, label, icon: Icon }]) => (
                <li key={key}>
                  <NavLink
                    replace
                    to={getCreateListingRoute(
                      dealRoomId,
                      id,
                      key as ListingType,
                    )}
                    className={classNames({
                      isActive: pathname.includes(route),
                    })}
                  >
                    <Icon />
                    {t(label)}
                  </NavLink>
                </li>
              ),
            )}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default BusinessInfoNavigation;
